import { render, staticRenderFns } from "./MessageSendWithAttachmentView.vue?vue&type=template&id=2fd5a058&scoped=true&"
import script from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
export * from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendWithAttachmentView.vue?vue&type=style&index=0&id=2fd5a058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5a058",
  null
  
)

export default component.exports